import React from 'react'
import { Filter } from 'storfox-filter'
import Grid from '@mui/material/Grid'
import { prop } from 'ramda'

import { arrayToParams, escapeAtob } from '~/utils'
import Accordion from '~/components/Accordion'
import * as API from '~/constants/api'
import AsyncMultiSelectField from '~/components/Fields/AsyncMultiSelectField'
import WarehouseMultiSelectField from '~/components/Fields/WarehouseMultiSelectField'

import { FILTER_NAME as name } from '../../constants/RetailerUnit'

export const toParams = values => {
  const warehouses = arrayToParams('warehouses', values)
  const companies = arrayToParams('companies', values)

  return {
    companies,
    warehouses
  }
}

export const toValues = params => {
  const companies = escapeAtob(prop('companies', params))
  const warehouses = escapeAtob(prop('warehouses', params))

  return {
    companies,
    warehouses
  }
}

export const transformer = { toParams, toValues }

export const inventoryFilterOptions = {
  name,
  transformer
}

function UnitFilterForm (props) {
  return (
    <Filter {...props}>
      <Accordion title="General" defaultExpanded={true}>
        <Grid container={true} spacing={2}>
          <Grid item={true} xs={12}>
            <WarehouseMultiSelectField name="warehouses" api={API.WAREHOUSE_LIST} />
          </Grid>
          <Grid item={true} xs={12}>
            <AsyncMultiSelectField
              api={API.UNIT_COMPANY_LIST}
              label="Companies"
              name="companies"
            />
          </Grid>
        </Grid>
      </Accordion>
    </Filter>
  )
}

export default UnitFilterForm
